import {FC, ReactNode, useReducer} from 'react';
import {TestContext, initialTestState} from './testContext';
import {testReducer} from './testReduser';

type IProps = {
  children: ReactNode;
};

const TestProvider: FC<IProps> = ({children}) => {
  const questionsStorage = localStorage.getItem('questions');
  const Questions = questionsStorage ? JSON.parse(questionsStorage) : [];
  const minCorrectAnswersCountStorage = localStorage.getItem('minCorrectAnswersCount');
  const MinCorrectAnswersCount = minCorrectAnswersCountStorage ? JSON.parse(minCorrectAnswersCountStorage) : Questions.length;

  const [state, dispatch] = useReducer(testReducer, {...initialTestState, Questions, MinCorrectAnswersCount});
  return <TestContext.Provider value={{state, dispatch}}>{children}</TestContext.Provider>;
};
export default TestProvider;
